export default {
  title: "East Landscape",
  locale: {
    english: "English",
    swedish: "Swedish",
  },
  localeShort: {
    english: "en",
    swedish: "sv",
  },
  about: "About East",
  portfolio: "Portfolio",
  contact: "Contact",
};
